exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".vI9X_-KTf09NmXtd6Ngvz{border-top:1px solid hsla(0,2%,60%,.5);padding-top:50px;margin-top:30px}", "", {"version":3,"sources":["/Users/mrodrigo/Documents/DEV/v2APP/src/components/templates/Event/ListCategories/style.css"],"names":[],"mappings":"AAAA,uBACI,uCAA+C,AAC/C,iBAAkB,AAClB,eAAiB,CACpB","file":"style.css","sourcesContent":[".categories {\n    border-top: 1px solid rgba(155, 151, 151, 0.5);\n    padding-top: 50px;\n    margin-top: 30px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"categories": "vI9X_-KTf09NmXtd6Ngvz"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/templates/Event/ListCategories/style.css
// module id = 986
// module chunks = 0 1 2 3